import React from "react";
import "./InfoSection.css";


const InfoSection = React.memo(function InfoSection({ text, textClassName, className }: { text?: string, textClassName?: string, className: string }) {
  return (
    <div className="info-section">
      <i className={className}></i>
      <span className={textClassName}>{text}</span>
    </div>
  )
})

export default InfoSection;